import { Link } from '@inertiajs/react'
import { CheckCircle2, CircleSlash, ExternalLink } from 'lucide-react'
import type { IncidentDetail, OperatorNavigationRef } from './types'

function signalLabel(value: string | null) {
  return value ? 'Registrado' : 'Ausente'
}

function signalTone(value: string | null) {
  return value ? 'text-emerald-700 bg-emerald-50 border-emerald-200' : 'text-muted-foreground bg-muted border-border'
}

export function RefValue({ item }: { item: OperatorNavigationRef }) {
  if (!item.href) return <span>{item.value}</span>

  const content = <>{item.value}<ExternalLink className="h-3 w-3" /></>

  if (item.external) {
    return <a href={item.href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-blue-600 hover:underline">{content}</a>
  }

  return <Link href={item.href} className="inline-flex items-center gap-1 text-blue-600 hover:underline">{content}</Link>
}

export function RefLine({ item }: { item: OperatorNavigationRef }) {
  return (
    <div className="border-b border-border py-2 last:border-b-0">
      <dt className="text-xs uppercase text-muted-foreground">{item.label}</dt>
      <dd className="text-sm text-foreground break-all">
        <RefValue item={item} />
      </dd>
    </div>
  )
}

function SignalRow({ label, value, state }: { label: string; value: string | null; state?: string }) {
  const present = Boolean(value)
  const Icon = present ? CheckCircle2 : CircleSlash

  return (
    <div className="flex items-start justify-between gap-3 border-b border-border py-2 last:border-b-0">
      <div className="min-w-0">
        <div className="text-sm font-medium text-foreground">{label}</div>
        <div className="text-xs text-muted-foreground break-all">{value || 'Sem referência'}</div>
      </div>
      <span className={`inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-xs ${signalTone(value)}`}>
        <Icon className="h-3 w-3" /> {state || signalLabel(value)}
      </span>
    </div>
  )
}

export function IncidentSignals({ incident }: { incident: IncidentDetail }) {
  return (
    <section>
      <h3 className="text-sm font-semibold text-foreground mb-2">Sinais</h3>
      <div className="bg-card border border-border rounded-lg px-4">
        <div className="border-b border-border py-2">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <div className="text-sm font-medium text-foreground">Trace</div>
              <div className="text-xs text-muted-foreground">{incident.traceState.message}</div>
              {incident.traceState.available && <div className="text-xs text-muted-foreground mt-1">Payload do incidente suprimido</div>}
            </div>
            <span className={`inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-xs ${signalTone(incident.traceUrl || incident.rootTraceId)}`}>
              {incident.traceState.available ? <CheckCircle2 className="h-3 w-3" /> : <CircleSlash className="h-3 w-3" />}
              {incident.traceState.label}
            </span>
          </div>
        </div>
        <SignalRow label="Log" value={incident.logRef} />
        <SignalRow label="Stability" value={incident.stabilityBundleRef} />
        <SignalRow label="Cron" value={incident.cronRunRef} />
      </div>
    </section>
  )
}
